<template>
  <div v-if="images.length>0">
    <van-swipe class="my-swipe" :autoplay="300000">
      <van-swipe-item
        v-for="(image, index) in images"
        :key="index"
      >
        <slot></slot>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "GSwiper",
  props: {
    images: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      getImages: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
.my-swipe {
  height: 300px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.img {
  width: 100%;
}
</style>
